import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type { Action, ThunkAction } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export interface ThunkExtra {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  configFlagsApolloClient: ApolloClient<NormalizedCacheObject>;
}

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, ThunkExtra, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
